import { useState, useEffect, useContext } from "react"
import { TbSongs } from "../../components/tables/TbSongs"
import { validateSongs } from "../../helpers/validateForms"
import { ContextApp } from "../../context/ContextApp"

import Titulo from "../../components/titles/Titulo"
import InputSearch from "../../components/inputs/inputs/InputSearch"
import InputJim from "../../components/inputs/inputs/InputJim"
import CheckJim from "../../components/inputs/inputs/CheckJim"

import '../pageStyles.css'
import './songs.css'
import ModalConfirm from "../../components/ModalComfirm/ModalConfirm"

const Songs = () => {

  const initialErrors = {
    titulo: '',
    duracion: '',
    anyo: '',
  }

  const { loginUp, token, refreshToken, artista, cancion } = useContext(ContextApp);

  const [errors, setErrors] = useState(initialErrors);
  const [song, setSong] = useState(cancion)
  const [songs, setSongs] = useState([])
  const [artists, setArtists] = useState([])
  const [songsFiltred, setSongsFiltred] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [modoAdd, setModoAdd] = useState(true)

  useEffect(() => {
    const loadData = async () => {
      try {
        await refreshToken();
        const data = await cancion.getSongs();
        setSongs(await data);
        setSongsFiltred(await data);
        const art = await artista.getArtists();
        setArtists(await art);
      } catch (error) {
        console.log(error.message)
      }
    }
    loadData();
  }, [artista, cancion, loginUp, refreshToken])

  const filterData = (data) => {
    const newData = songs.filter((song) => song.CAN_TITULO.toLowerCase().includes(data.toLowerCase()))
    setSongsFiltred(newData)
  }
  const onChange = (e) => {
    handleChange(e.target.name, e.target.value)
  }
  const handleChange = (name, value) => {
    setSong({ ...song, [name]: value })
    if (name === 'anyo') validateData(name, value)
  }
  const validateData = async(name, value) => {
    const error = await validateSongs(name, value)
      setErrors(prevErrors =>{
        return {...prevErrors, [name]:error}
      })
  }
  const sendForm = async () => {
    try {
      await refreshToken()

      await validateData('titulo', song.titulo)
      await validateData('duracion', song.duracion)
      await validateData('anyo', song.anyo)


      if (song.titulo.length > 2 && song.duracion !== '' && song.anyo !== '') {
        modoAdd 
          ? setSongsFiltred(await cancion.addSong(song, token))
          : setSongsFiltred(await cancion.updateSong(song, token))
        setShowForm(false)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const updateSong = (e) => {
    setSong({
      ...song,
      id: e.CAN_CLAVE,
      titulo: e.CAN_TITULO,
      visible: e.CAN_VISIBLE.data[0],
      duracion: e.CAN_DURACION,
      anyo: e.CAN_ANYO,
      idArtista: e.CAN_CLAART,
    })
    console.log('---------')
    console.log(song.visible)
    console.log(e.CAN_VISIBLE)
    setShowForm(true)
    setModoAdd(false)
  }
  const deleteSong = async () => {
    setShowModal(!showModal);
 
      await refreshToken()
      const data = await cancion.delSong(song.CAN_CLAVE, token)
      setSongsFiltred(data)
      setSong(cancion)

  }
  const showPopup = (e) => {
    setSong(e)
    setShowModal(!showModal) 

  }

  return (
    <>
      <div className="container-data">

        <section className="data-body">

          <section className="data-header">
            <Titulo>CANCIONES</Titulo>

            <InputSearch
              placeholder='título a buscar'
              onChange={filterData} />
            <button className="material-icons-outlined btn" onClick={() => setShowForm(!showForm)}>add</button>
          </section>

          {songs &&
            <section className="data-table">

              <TbSongs
                songs={songsFiltred}
                updateSong={updateSong}
                deleteSong={showPopup}
              />

            </section>
          }
        </section>

        <section className="data-edit">
          {showForm &&
            <section className="data-form">

              <InputJim classN='span'
                type='text'
                name='titulo'
                value={song.titulo}
                onChange={handleChange}
                onBlur={validateData}
                placeholder='escribe título'
                error={errors.titulo} />
              <InputJim classN='span'
                type='time'
                name='duracion'
                value={song.duracion}
                onChange={handleChange}
                onBlur={validateData}
                placeholder='00:00'
                error={errors.duracion} />
              <InputJim
                type='number'
                name='anyo'
                value={song.anyo}
                onChange={handleChange}
                onBlur={validateData}
                placeholder='año'
                error={errors.anyo} />
              <CheckJim
                name='visible'
                label='Visible'
                value={song.visible}
                onChange={handleChange}
                error='' />

              <select className="select-container select-input span"
                name='idArtista'
                value={song.idArtista}
                onChange={onChange}
              >
                {artists && artists.map((item) => (
                  <option key={item.ART_CLAVE} value={item.ART_CLAVE} >
                    {item.ART_NOMBRE}
                  </option>
                ))}
              </select>

              <button className="btn posButton" onClick={sendForm}>ENVIAR</button>
            </section>
          }
          <div className={showForm ? "data-logo hidden" : "data-logo"} />
        </section>

      </div>

      {showModal &&
        <ModalConfirm title='Confirmar eliminación' showPopup={showPopup}>
          <>
            <section className='modal-message'>
              <h2>Vas a eliminar la canción</h2>
              <h2> {song.CAN_TITULO} de {song.ART_NOMBRE} </h2>
            </section>
            <section className='modal-buttons'>
              <button onClick={deleteSong}>ACEPTAR</button>
              <button onClick={showPopup}>CANCELAR</button>
            </section>
          </>
        </ModalConfirm>
      }
    </>
  )
}
export default Songs